var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.$isMobile ? '':'sidebars'},[_c('v-main',{staticClass:"center"},[_c('router-view')],1),_c('div',{staticClass:"version"},[_c('span',[_vm._v("version")]),_vm._v(" "+_vm._s(_vm.version)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }